import React, { useState, useEffect, useLayoutEffect, useCallback } from "react";
import { useStyles } from "../OnePass/styles";
import clsx from "clsx";
import { useLocation } from "react-router-dom";
import AuthService from "../../services/AuthService";
import apiClient, { setAuthentication as setApiAuth } from "../../auth/apiClient";
import { setAuthenticationState } from "../../reducers/auth/authReducer";
import WalletService from "../../services/WalletService";
import GenericError from "../../components/MobilePayment/GenericError";
import useAuthContext from "../../hooks/useAuthContext";
import { Grid, CircularProgress } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";

const authService = new AuthService(apiClient);
const walletService = new WalletService(apiClient);

const GoogleWalletPassPage = () => {
  const classes = useStyles();
  const location   = useLocation();
  const queryparams =new URLSearchParams(location.search);
  const identifier = queryparams.get("identifier");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { authReducer } = useAuthContext();
  const [, authDispatch] = authReducer;
  const theme = useTheme();

  const getAuth = async () => {
    try {
      var appClientToken = await authService.getMobilePayAuthToken();
      if (appClientToken !== "") {
        setApiAuth(appClientToken);
        authDispatch({
          type: setAuthenticationState,
          payload: { properties: [] },
        });
        setIsAuthenticated(true);
      }
    } catch (error) {
      console.error("Error Authenticating", error);
    }
  };

  const downloadWalletPass = useCallback(async () => {
    try {
      const response = await walletService.createGoogleWalletPass(identifier);
      const url = response.data;
      const link = document.createElement("a");
      link.href = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setIsLoading(false);
    } catch (error) {
      setErrorMessage(["Error creating Google Wallet Pass."]);
      setIsLoading(false);
    }
  }, [identifier]);

  useEffect(() => {
    if (!isAuthenticated) {
      getAuth();
    }
  }, [authDispatch, isAuthenticated]);

  useEffect(() => {
    if (identifier && isAuthenticated) {
      downloadWalletPass();
    }
  }, [identifier, isAuthenticated, downloadWalletPass]);

  useLayoutEffect(() => {
    document.body.style.backgroundColor = theme.palette.background.level1;
  }, []);

  return (
    <div className={clsx(classes.root)}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <img className={classes.logo} alt="company logo" src="/images/logos/a1-logo-stacked-dark.svg" />
        </Grid>
      </Grid>
      <div className={clsx(classes.contentContainer, classes.walletPassContent)}>
        {isLoading ? (
          <>
            <div>Wallet pass download initiated.</div>
            <br></br>
            <CircularProgress size={60} />
          </>
        ) : (
          errorMessage ? (
            <GenericError message={errorMessage}></GenericError>
          ) : (
            <div>Please check wallet for your pass.</div>
          )
        )}
      </div>
    </div>
  );
};

export default GoogleWalletPassPage;